<agr-print-page orientation="landscape" [showFooter]="false" [showHeaderImage]="false">
  <article class="dashboard-report-print" data-test="dashboard-report-print">
    <img class="dashboard-report-print__logo" src="assets/report-print/logo2.png" alt="Agrifirm" />

    <header class="dashboard-report-print__header">
      <h2>{{ report.title }}</h2>
      <p class="dashboard-report-print__subtitle">{{ report.subTitle }}</p>
    </header>

    @if (report.legend.length) {
      <section class="dashboard-report-print__legend" aria-label="Report legend">
        <table>
          <thead>
            <tr>
              <th scope="col">Property</th>
              <th scope="col">Value</th>
            </tr>
          </thead>
          <tbody>
            @for (item of report.legend; track item.heading) {
              <tr>
                <td>{{ item.heading }}</td>
                <td>{{ item.value }}</td>
              </tr>
            }
          </tbody>
        </table>
      </section>
    }

    <table class="dashboard-report-print__table">
      <thead>
        <tr>
          @for (heading of report.tableHeadings; track $index) {
            <th>{{ heading }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of report.rows; track $index) {
          <tr [class]="row.class">
            @for (column of row.value; track $index) {
              <td [class]="column.class" [attr.colspan]="column.colspan">
                <div>{{ column.value }}</div>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>

    <footer class="dashboard-report-print__footer">
      <div class="dashboard-report-print__footer-text">
        @for (line of report.tableFooter; track $index) {
          <p>{{ line }}</p>
        }
      </div>

      <div class="dashboard-report-print__footer-bottom">
        <div class="dashboard-report-print__contact-information">
          <div class="dashboard-report-print__contact-column">
            Agrifirm NWE BV<br />Landgoedlaan 20<br />Postbus 20004<br />7302 HA Apeldoorn
          </div>
          <div class="dashboard-report-print__contact-column">
            BTW NL007611900B01<br />KvK 16050353
          </div>
          @if (report.contactInformation) {
            <div class="dashboard-report-print__contact-column">
              @if (report.contactInformation.url) {
                <span>{{ report.contactInformation.url }}</span
                ><br />
              }
              @if (report.contactInformation.phoneNumber) {
                <span>{{ report.contactInformation.phoneNumber }}</span
                ><br />
              }
              @if (report.contactInformation.email) {
                <span>{{ report.contactInformation.email }}</span>
              }
            </div>
          }
        </div>
        <div class="dashboard-report-print__better-together">
          <h2><em>Better Together</em></h2>
          <div><span></span><span></span></div>
        </div>
      </div>
    </footer>
  </article>
</agr-print-page>
